import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_AGENTE_CONSULTA, ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { TaxaJurosMaximaAgente } from 'src/app/model/taxa-juros-maxima-agente.model';
import { TaxaJurosMediaMaximaAgente } from 'src/app/model/taxa-juros-media-maxima-agente.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { TaxaJurosMaximaAgenteService } from 'src/app/shared/services/taxa-juros-maxima-agente.service';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';

@Component({
    selector: 'app-taxa-juros-maxima-agente-listagem',
    templateUrl: './taxa-juros-maxima-agente-listagem.component.html',
    styleUrls: ['./taxa-juros-maxima-agente-listagem.component.scss'],
    standalone: false
})
export class TaxaJurosMaximaAgenteListagemComponent implements OnInit {

    public taxasJurosMaximaAgentes: TaxaJurosMaximaAgente[] = [];
    public permissaoEdicao = false;

    public podeEscolherAgente = false;

    public cnpjAgenteFinanceiro: string;

    public tranches: Tranche[];

    constructor (private taxaJurosMaximaAgenteService: TaxaJurosMaximaAgenteService,
        private permissaoService: PermissaoService,
        private bnUsuarioService: BnUsuarioService,
        private trancheService: TrancheService,
        private datePipe: DatePipe) {
    }

    public adicionarTaxaJurosMaximaAgente() {
        let taxa = new TaxaJurosMaximaAgente();
        taxa.modoEdicao = true;
        this.getTaxasJurosMaximaAgentes().unshift(taxa);
    }

    private getTaxasJurosMaximaAgentes(): TaxaJurosMaximaAgente[] {
        return this.taxasJurosMaximaAgentes;
    }

    private setTaxasJurosMaximaAgentes(taxasJurosMaximaAgentes: TaxaJurosMaximaAgente[]) {
        if (taxasJurosMaximaAgentes) {
            for (let taxa of taxasJurosMaximaAgentes) {
                taxa.dataInicioValidade = this.ajustaCampoDate(taxa.dataInicioValidade);
            }
        }
        return this.taxasJurosMaximaAgentes = taxasJurosMaximaAgentes;
    }

    public salvarTaxaJurosMaximaAgente(taxa: TaxaJurosMaximaAgente) {
        this.taxaJurosMaximaAgenteService.salvar(taxa).subscribe((resp) => {
            resp.dataInicioValidade = this.ajustaCampoDate(resp.dataInicioValidade);
            const pos = this.getTaxasJurosMaximaAgentes().indexOf(taxa);
            this.getTaxasJurosMaximaAgentes()[pos] = resp;
        });
    }

    public removerTaxaJurosMaximaAgente(taxa: TaxaJurosMaximaAgente) {
        if (taxa.id) {
            this.taxaJurosMaximaAgenteService.remover(taxa.id).subscribe(() => {
                const pos = this.getTaxasJurosMaximaAgentes().indexOf(taxa);
                this.getTaxasJurosMaximaAgentes().splice(pos, 1);
            });
        }
        else {
            const pos = this.getTaxasJurosMaximaAgentes().indexOf(taxa);
            this.getTaxasJurosMaximaAgentes().splice(pos, 1);
        }
    }

    public editarTaxaJurosMaximaAgente(taxa: TaxaJurosMaximaAgente) {
        taxa.dataInicioValidadeOriginal = taxa.dataInicioValidade;
        taxa.taxaJurosMaximaAgenteOriginal = taxa.taxaJurosMaximaAgente;
        taxa.modoEdicao = true;
    }

    public cancelarEdicaoTaxaJurosMaximaAgente(taxa: TaxaJurosMaximaAgente) {
        if (taxa.id) {
            taxa.dataInicioValidade = taxa.dataInicioValidadeOriginal;
            taxa.taxaJurosMaximaAgente = taxa.taxaJurosMaximaAgenteOriginal;
            taxa.modoEdicao = false;
        }
        else {
            this.removerTaxaJurosMaximaAgente(taxa);
        }
    }
       
    public ngOnInit() {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            if (resp && (resp[ROLE_GESTOR_ENVIO] || resp[ROLE_GESTOR_CONSULTA])) {
                this.podeEscolherAgente = true;
            }
            if (resp && resp[ROLE_GESTOR_ENVIO]) {
                this.permissaoEdicao = true;
            }
            

            this.trancheService.getTranches().subscribe (tranches => {
                this.tranches = tranches;
              });
        });

        this.taxaJurosMaximaAgenteService.buscarTodos().subscribe(resp => {
            this.setTaxasJurosMaximaAgentes(resp);
        });
    }

    public nomeTranche(id) {
        for (let tranche of this.tranches) {
            if (tranche.id == id) {
                return tranche.numeroTranche + " (" + this.datePipe.transform(tranche.dataInicioContratacao, 'dd/MM/yyyy') + ")";
            }
        }

        return "Tranche não encontrada";
    }

    ajustaCampoDate(data:any) {
        if (typeof data === 'string') {
          if (data.length == 10) {
            data += ' 00:00:00';
          }
          return new Date(data);
        }
    
        return data;
      }
}